module.exports = __webpack_public_path__ + "img/slider-bg-1.61615452.svg";